// @ts-nocheck
import getCurrentLanguageKey from 'Jsx/Utils/getCurrentLanguageKey';
import es from './es';
import pt from './pt';

export const LOCALES = {
  es,
  pt,
};

const currentLang = getCurrentLanguageKey();

export default LOCALES[currentLang];
